export function mediaError(error: unknown): string {
    const name = error && typeof error === "object" && "name" in error ? String(error.name) : "";
    if (name === "NotAllowedError" || name === "PermissionDeniedError") return "Доступ до камери не надано. Дозвольте його в налаштуваннях цього сайту й спробуйте ще раз.";
    if (name === "NotFoundError" || name === "DevicesNotFoundError") return "Камеру не знайдено. Можна відкрити локальний відеофайл або фото.";
    if (name === "NotReadableError" || name === "TrackStartError") return "Камера зараз недоступна або використовується іншим застосунком.";
    if (name === "OverconstrainedError") return "Камера не підтримує вибрані параметри. Спробуйте інший пристрій.";
    return error instanceof Error ? error.message : "Не вдалося відкрити медіаджерело.";
}

export function stopStream(stream: MediaStream | null): void {
    stream?.getTracks().forEach(track => track.stop());
}

export function captureFrame(source: HTMLVideoElement | HTMLImageElement, canvas: HTMLCanvasElement, maxEdge = 640) {
    const width = source instanceof HTMLVideoElement ? source.videoWidth : source.naturalWidth;
    const height = source instanceof HTMLVideoElement ? source.videoHeight : source.naturalHeight;
    if (!width || !height) throw new Error("Кадр ще не завантажився.");
    const scale = Math.min(1, maxEdge / Math.max(width, height));
    canvas.width = Math.max(1, Math.round(width * scale)); canvas.height = Math.max(1, Math.round(height * scale));
    const context = canvas.getContext("2d", { willReadFrequently: true });
    if (!context) throw new Error("Браузер не підтримує обробку кадрів.");
    context.drawImage(source, 0, 0, canvas.width, canvas.height);
    return { pixels: context.getImageData(0, 0, canvas.width, canvas.height).data.buffer as ArrayBuffer, width: canvas.width, height: canvas.height };
}
